import { FaDice } from 'react-icons/fa';
import { backendUrl } from '@common/contracts';
// The canonical node types are the game's PortalLocationType, each rendered with
// the game's own icon (copied from the game frontend's
// src/assets/challenges/PortalLocationType). Keyed by NodeType.name. Note the
// name≠file cases inherited from the game (Building→Construction, Machine→Gear,
// Battle→Combat, Vehicle→Transport).
import Start from '../../assets/nodeTypeIcons/start.webp';
import Empty from '../../assets/nodeTypeIcons/empty.webp';
import Danger from '../../assets/nodeTypeIcons/Danger.webp';
import Construction from '../../assets/nodeTypeIcons/Construction.webp';
import Treasure from '../../assets/nodeTypeIcons/Treasure.webp';
import Gear from '../../assets/nodeTypeIcons/Gear.webp';
import Camp from '../../assets/nodeTypeIcons/Camp.webp';
import Psi from '../../assets/nodeTypeIcons/Psi.webp';
import Combat from '../../assets/nodeTypeIcons/Combat.webp';
import Shield from '../../assets/nodeTypeIcons/Shield.webp';
import Nature from '../../assets/nodeTypeIcons/Nature.webp';
import Transport from '../../assets/nodeTypeIcons/Transport.webp';
import Resource from '../../assets/nodeTypeIcons/Resource.webp';
import Statue from '../../assets/nodeTypeIcons/Statue.webp';
import Bridge from '../../assets/nodeTypeIcons/Bridge.webp';
import Water from '../../assets/nodeTypeIcons/Water.webp';
import Mountain from '../../assets/nodeTypeIcons/Mountain.webp';
import Air from '../../assets/nodeTypeIcons/Air.webp';
import Snow from '../../assets/nodeTypeIcons/Snow.webp';
import Electricity from '../../assets/nodeTypeIcons/Electricity.webp';
import Agility from '../../assets/nodeTypeIcons/Agility.webp';
import Intellect from '../../assets/nodeTypeIcons/Intellect.webp';
import Defense from '../../assets/nodeTypeIcons/Defense.webp';
import Perception from '../../assets/nodeTypeIcons/Perception.webp';
import Strength from '../../assets/nodeTypeIcons/Strength.webp';
/** The full, canonical node-type list (order = game PortalLocationType order). */
export const NODE_TYPE_NAMES = [
    'Start', 'Empty', 'Danger', 'Building', 'Treasure', 'Machine', 'Camp', 'Psi',
    'Battle', 'Shield', 'Nature', 'Vehicle', 'Resource', 'Statue', 'Bridge', 'Water',
    'Mountain', 'Air', 'Snow', 'Electricity', 'Agility', 'Intellect', 'Defense',
    'Perception', 'Strength',
];
const NODE_TYPE_ICON_URLS = {
    Start, Empty, Danger, Building: Construction, Treasure, Machine: Gear, Camp, Psi,
    Battle: Combat, Shield, Nature, Vehicle: Transport, Resource, Statue, Bridge, Water,
    Mountain, Air, Snow, Electricity, Agility, Intellect, Defense, Perception, Strength,
};
/** The canonical game icon for a node type name, or undefined if the name isn't a
 *  canonical type (so callers can fall back to a custom uploaded image). */
export const getCanonicalNodeTypeIconUrl = (name) => name ? NODE_TYPE_ICON_URLS[name] : undefined;
/** Resolve a node type name to its icon image URL (falls back to the Empty glyph). */
export const getNodeTypeIconUrl = (name) => { var _a; return (_a = getCanonicalNodeTypeIconUrl(name)) !== null && _a !== void 0 ? _a : Empty; };
/** Shown while no node type is picked — the "random / unset" placeholder glyph. */
export const NODE_TYPE_PLACEHOLDER_ICON = FaDice;
/**
 * Resolve a node type's icon SRC. The DB `image` is the single source of truth
 * (seeded from the game art, admin-editable); the bundled canonical glyph is a
 * fallback only for types without a stored image. Handles relative /uploads,
 * absolute http(s) and data: URLs.
 */
export const resolveNodeTypeIconSrc = (nodeType) => {
    const img = nodeType === null || nodeType === void 0 ? void 0 : nodeType.image;
    if (img)
        return (img.startsWith('http') || img.startsWith('data:')) ? img : `${backendUrl}${img}`;
    return getNodeTypeIconUrl(nodeType === null || nodeType === void 0 ? void 0 : nodeType.name);
};
